import $axios from '../api.js'

const state = () => ({
    sender: []
})

const mutations = {
    SET_SENDER(state, payload){
        state.sender = payload
    }
}

const actions = {
    getSender({commit}){
        return new Promise(() => {
            $axios.get('/sender')
            .then((response) => {
                commit('SET_SENDER', response.data.data)
            })
        })
    },
    requestCode({state}, payload){
        return new Promise((resolve, reject) => {
            $axios.post('/sender/request-code', payload)
            .then((response) => {
                console.log(state.sender)
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}